module.exports = __webpack_public_path__ + "static/media/cb_1.8f387e30.svg";